module.exports = __webpack_public_path__ + "img/8.4c5e8a7.png";